const model = {
    name: 'Suggestion',
    properties: {
        exclude: {},
        keyphrase_fallback: {},
        max: {},
        name: { required: true },
    },
};
export default model;
